import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { relayPaymentAction, relayPaymentEclipseOpsAction } from "@mobile-dev/platform/common/redux/actions/RelayPaymentAction";
import PaymentMethod from "./PaymentMethod";
import { dollarToCents, getApplicationFlow, getCarrierEnteredMobileNumber, isEclipseOpsTruck, showAlert } from "../../../../../Utils/Utility";
import { AppConstatnt } from "../../../../../Utils/AppConstant";
import { toast } from "react-toastify";
import { injectIntl } from 'react-intl';
import moment from "moment";

function RelayPayment({ intl, ...props }) {
    const dispatch = useDispatch();
    const transaction = useSelector(state => state.relayPayment);
    const location = useLocation();
    let [error, setError] = useState(false)
    const amount = location.state.amount;
    const originalAmount = location?.state?.originalAmount;
    const remainingAmount = location.state.remainingAmount;
    const selection = location.state.selection;
    const history = useHistory();
    const id = location.state.id;
    const total_bill_amount = location.state.total_bill_amount;
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user.attributes;
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id);
    const load_control_num = load?.load_control_num;
    const warehouse_id = load?.warehouse_id;
    const paymentmethods = location.state.paymentmethods;
    const { formatMessage } = intl;
    const serviceFee = location.state.serviceFee;

    function handleSubmit(paymentData) {
        let driver_phone = getApplicationFlow() === 'Carrier' ? getCarrierEnteredMobileNumber() : userData.phone_number;
        if (paymentData.val1.length === 6) {
            initiateRelayPayment(paymentData, driver_phone)
        }
        else {
            showAlert(toast.TYPE.WARNING, "Enter a valid Relay Code of 6 characters.")
        }


    }

    const initiateRelayPayment = (paymentData, driver_phone) => {
        if (isEclipseOpsTruck(load)) {
            const transactionData = {
                recID: id,
                transactionType: "RELAY",
                paymentCode: paymentData.val1,
                driverLastName: auth?.user?.attributes?.family_name,
                driverFirstName: auth?.user?.attributes?.given_name,
                carrierName: "",
                fullAmount: amount,
                driverPhoneNumber: driver_phone,
                user_number: driver_phone,
                transactionDateTime: moment(),
                timeZone: "UTC+6",
                unitNum: null,
                tripNum: null,
                relaySiteId: warehouse_id,
                tabletype: "eclipseOps",
                serviceFee: serviceFee,
                paymentType: selection,
            }
            dispatch(relayPaymentEclipseOpsAction(transactionData))

        } else {
            const relayData = {
                amount: dollarToCents(amount),
                code: paymentData.val1,
                warehouse_id: warehouse_id,
                load_id: id,
                driver_phone,
                load_control_num: load_control_num
            }
            dispatch(relayPaymentAction(relayData));
        }
    }

    const getTransID = () => {
        if (isEclipseOpsTruck(load)) {
            const status = transaction?.transactionStatus?.status || null
            return status ? (status === 'closed' ? "Success" : "Failed") : null
        } else {
            return transaction.transactionStatus
        }

    }
    return (
        <React.Fragment>
            <PaymentMethod
                id={id}
                loading={transaction.loading}
                onSubmitClick={handleSubmit}
                error={transaction.error?.message}
                transactionId={getTransID()}
                title={formatMessage({ id: "app.relay_payment" })}
                paymentCodeName={`Relay ${formatMessage({ id: "app.payment_code" })}`}
                amount={amount}
                originalAmount={originalAmount}
                remainingAmount={remainingAmount}
                selection={selection}
                length={6}
                remainingAmount={remainingAmount}
                selection={selection}
                paymentType={AppConstatnt.RELAY}
                message={formatMessage({ id: "app.view_payment_details" })}
                total_bill_amount={total_bill_amount}
                paymentmethods={paymentmethods}
                serviceFee={serviceFee}
            />
        </React.Fragment>
    )


}

export default injectIntl(RelayPayment);